export const API_URL_WORKSPACE: string = "https://api.workspace.vegait.rs";
export const MAPBOX_KEY: string =
  "pk.eyJ1IjoibWxhZGpvMTIiLCJhIjoiY2wydTl3ZTduMDAxODNjcXR4cmltd2dvYSJ9.m6clNxFm7XSGF4b81H1eEw";